import { MutationCache, QueryClient, matchQuery, type QueryKey } from "@tanstack/react-query";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      invalidateQueries?: Array<QueryKey>;
    };
  }
}

export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          // invalidate all matching tags at once
          // or everything if no meta is provided
          mutation.meta?.invalidateQueries?.some((queryKey) => matchQuery({ queryKey }, query)) ??
          true,
        refetchType: "all",
      });
    },
  }),
});
